/*
 * Taffstyle Produktbeschreibungen — Version 1.3, 24.09.2026
 * Einmal als Asset taffstyle-produktbeschreibung.js in der Theme-Kopie speichern.
 * In layout/theme.liquid unmittelbar vor </body> einbinden:
 * <script src="{{ 'taffstyle-produktbeschreibung.js' | asset_url }}" defer></script>
 * Das Skript verändert ausschließlich die Darstellung erkannter Beschreibungen.
 * Produktdaten und Afterbuy bleiben unverändert. Unbekannte Vorlagen bleiben stehen.
 * Rückbau: Script-Einbindung entfernen und Seite neu laden.
 */
(() => {
  'use strict';
  const KEY = 'TaffstyleDescriptions';
  if (window[KEY]) { window[KEY].scan(); return; }
  const BLOCK = '.block-content_H9jQNg.accordion-a';
  const SOURCE_MARK = 'data-tsp-original';
  const PROMO_MARK = 'data-tsp-promo';
  const LEGACY_MEDIA_MARK = 'data-tsp-legacy-media';
  const CSS = ".block-content_H9jQNg.accordion-a [data-tsp-original=\"1\"], .block-content_H9jQNg.accordion-a [data-tsp-promo=\"1\"], .block-content_H9jQNg.accordion-a [data-tsp-legacy-media=\"1\"] { display: none !important; }\n.block-content_H9jQNg.accordion-a .tsp-legacy-wrapper { float: none !important; width: auto !important; margin: 0 !important; }\n.tsp-description { --tsp-ready: 1; --tsp-ink: #262326; --tsp-muted: #262326; --tsp-pink: #eee1f5; --tsp-accent: #5a0d75; --tsp-line: #e4d6ea; display: block; clear: both; width: 100%; min-width: 0; margin: 0; padding: 0; color: var(--tsp-ink); font: inherit; text-align: left; }\n.tsp-description, .tsp-description * { box-sizing: border-box; }\n.tsp-description section { display: block; min-width: 0; margin: 0; padding: 0; border: 0; background: transparent; }\n.tsp-description .tsp-introduction { margin-bottom: 26px; }\n.tsp-description .tsp-copy { font-size: 14px; line-height: 1.7; color: var(--tsp-muted); overflow-wrap: anywhere; }\n.tsp-description .tsp-copy p { margin: 0 0 12px; padding: 0; color: inherit; font-size: inherit; line-height: inherit; }\n.tsp-description .tsp-copy p:last-child { margin-bottom: 0; }\n.tsp-description .tsp-copy h2, .tsp-description .tsp-copy h3, .tsp-description .tsp-copy h4, .tsp-description .tsp-copy h5, .tsp-description .tsp-copy h6 { margin: 16px 0 8px; color: var(--tsp-ink); font-size: 15px; line-height: 1.5; font-weight: 700; text-transform: none; letter-spacing: 0; }\n.tsp-description .tsp-heading { display: flex; align-items: center; gap: 9px; margin: 0 0 13px; padding: 0; color: var(--tsp-ink); font-size: 15px; line-height: 1.5; font-weight: 700; text-transform: none; letter-spacing: 0; }\n.tsp-description .tsp-fields { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 10px; }\n.tsp-description dl.tsp-field { display: block; min-width: 0; width: auto; margin: 0; padding: 15px 16px; border: 0; border-radius: 11px; background: var(--tsp-pink); box-shadow: none; }\n.tsp-description .tsp-field:last-child:nth-child(odd), .tsp-description .tsp-field-wide { grid-column: 1 / -1; }\n.tsp-description .tsp-field dt { display: block; float: none; width: auto; margin: 0 0 5px; padding: 0; color: var(--tsp-ink); font-size: 12px; line-height: 1.5; font-weight: 600; overflow-wrap: anywhere; }\n.tsp-description .tsp-field dd { display: block; float: none; width: auto; margin: 0; padding: 0; color: var(--tsp-ink); font-size: 14px; line-height: 1.55; font-weight: 500; overflow-wrap: anywhere; }\n.tsp-description .tsp-field .tsp-copy { color: inherit; line-height: inherit; font-size: inherit; }\n.tsp-description .tsp-folds { margin-top: 24px; border-top: 1px solid var(--tsp-line); }\n.tsp-description .tsp-fold { display: block; margin: 0; padding: 0; border: 0; border-bottom: 1px solid var(--tsp-line); border-radius: 0; background: transparent; }\n.tsp-description .tsp-fold:last-child { border-bottom: 0; }\n.tsp-description .tsp-fold::before, .tsp-description .tsp-fold::after { content: none !important; }\n.tsp-description .tsp-fold > summary { position: relative; display: grid; grid-template-columns: 36px minmax(0, 1fr) 18px; align-items: center; gap: 12px; min-height: 66px; margin: 0; padding: 12px 0; list-style: none; background: transparent; color: var(--tsp-ink); font-size: 14px; line-height: 1.5; font-weight: 700; text-transform: none; letter-spacing: 0; cursor: pointer; }\n.tsp-description .tsp-summary:focus-visible { outline: 2px solid var(--tsp-accent); outline-offset: 3px; }\n.tsp-description .tsp-summary::-webkit-details-marker { display: none; }\n.tsp-description .tsp-summary::marker { content: ''; }\n.tsp-description .tsp-summary::before, .tsp-description .tsp-summary::after { content: none !important; }\n.tsp-description .tsp-summary-label { min-width: 0; overflow-wrap: anywhere; }\n.tsp-description .tsp-summary .tsp-icon-badge { display: flex !important; position: static !important; inset: auto !important; align-items: center; justify-content: center; width: 36px; height: 36px; margin: 0 !important; padding: 0; border: 0; border-radius: 10px; line-height: 0; background: var(--tsp-pink); }\n.tsp-description img.tsp-icon { display: block !important; position: static !important; inset: auto !important; float: none !important; flex: 0 0 20px !important; width: 20px !important; height: 20px !important; min-width: 20px !important; min-height: 20px !important; max-width: 20px !important; max-height: 20px !important; margin: 0 !important; padding: 0 !important; border: 0 !important; border-radius: 0 !important; box-shadow: none !important; object-fit: contain !important; transform: none !important; }\n.tsp-description img.tsp-chevron { width: 16px !important; height: 16px !important; min-width: 16px !important; min-height: 16px !important; max-width: 16px !important; max-height: 16px !important; }\n.tsp-description .tsp-fold[open] > summary img.tsp-chevron { transform: rotate(180deg) !important; }\n.tsp-description .tsp-fold > .tsp-fold-body { padding: 0 0 18px 48px; }\n.tsp-description .tsp-fold:not([open]) > .tsp-fold-body { display: none; }\n.tsp-description .tsp-copy ul, .tsp-description .tsp-copy ol { display: block; margin: 0; padding: 0 0 0 20px; list-style-position: outside; }\n.tsp-description .tsp-copy ul { list-style-type: disc; }\n.tsp-description .tsp-copy li { display: list-item; margin: 0 0 8px; padding: 0; line-height: inherit; }\n.tsp-description .tsp-copy li:last-child { margin-bottom: 0; }\n.tsp-description .tsp-copy a { color: var(--tsp-accent); text-decoration: underline; text-underline-offset: 3px; overflow-wrap: anywhere; }\n.tsp-description .tsp-copy img { display: block; position: static; max-width: 100%; height: auto; margin: 10px 0; }\n@media (max-width: 460px) {\n  .tsp-description .tsp-fields { grid-template-columns: minmax(0, 1fr); gap: 8px; }\n  .tsp-description dl.tsp-field { padding: 12px 14px; }\n  .tsp-description .tsp-fold > .tsp-fold-body { padding-left: 0; }\n}\n";
  const ICONS = {"gem":"data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIgdmlld0JveD0iMCAwIDI0IDI0IiBmaWxsPSJub25lIiBzdHJva2U9IiM4OTU1NzMiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiPjxwYXRoIGQ9Ik0xMC41IDMgOCA5bDQgMTMgNC0xMy0yLjUtNiIvPjxwYXRoIGQ9Ik0xNyAzYTIgMiAwIDAgMSAxLjYuOGwzIDRhMiAyIDAgMCAxIC4wMTMgMi4zODJsLTcuOTkgMTAuOTg2YTIgMiAwIDAgMS0zLjI0NyAwbC03Ljk5LTEwLjk4NkEyIDIgMCAwIDEgMi40IDcuOGwyLjk5OC0zLjk5N0EyIDIgMCAwIDEgNyAzeiIvPjxwYXRoIGQ9Ik0yIDloMjAiLz48L3N2Zz4=","copy":"data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIgdmlld0JveD0iMCAwIDI0IDI0IiBmaWxsPSJub25lIiBzdHJva2U9IiM4OTU1NzMiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiPjxwYXRoIGQ9Ik0yMSA1SDMiLz48cGF0aCBkPSJNMTUgMTJIMyIvPjxwYXRoIGQ9Ik0xNyAxOUgzIi8+PC9zdmc+","list":"data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIgdmlld0JveD0iMCAwIDI0IDI0IiBmaWxsPSJub25lIiBzdHJva2U9IiM4OTU1NzMiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiPjxwYXRoIGQ9Ik0xMyA1aDgiLz48cGF0aCBkPSJNMTMgMTJoOCIvPjxwYXRoIGQ9Ik0xMyAxOWg4Ii8+PHBhdGggZD0ibTMgMTcgMiAyIDQtNCIvPjxwYXRoIGQ9Im0zIDcgMiAyIDQtNCIvPjwvc3ZnPg==","sparkles":"data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIgdmlld0JveD0iMCAwIDI0IDI0IiBmaWxsPSJub25lIiBzdHJva2U9IiM4OTU1NzMiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiPjxwYXRoIGQ9Ik0xMS4wMTcgMi44MTRhMSAxIDAgMCAxIDEuOTY2IDBsMS4wNTEgNS41NThhMiAyIDAgMCAwIDEuNTk0IDEuNTk0bDUuNTU4IDEuMDUxYTEgMSAwIDAgMSAwIDEuOTY2bC01LjU1OCAxLjA1MWEyIDIgMCAwIDAtMS41OTQgMS41OTRsLTEuMDUxIDUuNTU4YTEgMSAwIDAgMS0xLjk2NiAwbC0xLjA1MS01LjU1OGEyIDIgMCAwIDAtMS41OTQtMS41OTRsLTUuNTU4LTEuMDUxYTEgMSAwIDAgMSAwLTEuOTY2bDUuNTU4LTEuMDUxYTIgMiAwIDAgMCAxLjU5NC0xLjU5NHoiLz48cGF0aCBkPSJNMjAgMnY0Ii8+PHBhdGggZD0iTTIyIDRoLTQiLz48Y2lyY2xlIGN4PSI0IiBjeT0iMjAiIHI9IjIiLz48L3N2Zz4=","chevron":"data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIgdmlld0JveD0iMCAwIDI0IDI0IiBmaWxsPSJub25lIiBzdHJva2U9IiM4OTU1NzMiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiPjxwYXRoIGQ9Im02IDkgNiA2IDYtNiIvPjwvc3ZnPg=="};
  const records = new Map();
  const diagnostics = new WeakMap();
  let observer, queued = false, enabled = true;
  const cleanText = text => String(text || '').replace(/\s+/g, ' ').trim();
  const canonical = text => String(text || '').replace(/[\s\u00a0\u2022]/g, '');
  const labelKey = text => cleanText(text).replace(/:\s*$/, '').toLocaleLowerCase('de');
  const descriptionKeys = new Set(['beschreibung', 'produktbeschreibung', 'artikelbeschreibung']);
  const noticeKeys = new Set(['hinweis', 'hinweise', 'wichtiger hinweis', 'wichtige hinweise']);
  const sectionKeys = new Set(['produktmerkmale', 'eigenschaften', 'pflege und reinigung', 'pflege & reinigung', 'pflegehinweise']);
  const anchors = new Set(['material', 'stückzahl', 'lieferumfang', 'inhalt', 'farbe', 'farben', 'größe', 'maße', 'durchmesser', 'stabstärke']);
  const isAnchorKey = key => anchors.has(key) || /^(?:material|farbe)(?:\s|$)/.test(key) || /durchmesser$/.test(key);
  const allowed = new Set(['P', 'BR', 'STRONG', 'B', 'EM', 'I', 'U', 'S', 'SMALL', 'SUB', 'SUP', 'UL', 'OL', 'LI', 'A', 'IMG', 'H2', 'H3', 'H4', 'H5', 'H6', 'BLOCKQUOTE', 'HR', 'SPAN', 'FONT', 'DIV']);

  function element(tag, className, text) {
    const node = document.createElement(tag);
    if (className) node.className = className;
    if (text !== undefined) node.textContent = text;
    return node;
  }
  function icon(name, className = '') {
    const image = element('img', 'tsp-icon ' + className);
    image.src = ICONS[name]; image.alt = ''; image.width = 20; image.height = 20;
    image.setAttribute('aria-hidden', 'true');
    return image;
  }
  function fingerprints(root) {
    return JSON.stringify({
      text: canonical(root.textContent),
      images: Array.from(root.querySelectorAll('img'), img => ['src', 'srcset', 'alt'].map(key => img.getAttribute(key))),
      links: Array.from(root.querySelectorAll('a'), a => a.getAttribute('href'))
    });
  }
  function safeLink(value) {
    if (!value) return value;
    const url = new URL(value, document.baseURI);
    if (!['http:', 'https:', 'mailto:', 'tel:'].includes(url.protocol)) throw new Error('Unbekanntes Linkformat');
    return value;
  }
  function copyNode(source) {
    if (source.nodeType === 3) return document.createTextNode(source.nodeValue);
    if (source.nodeType === 8) return document.createDocumentFragment();
    if (source.nodeType !== 1 || !allowed.has(source.tagName)) throw new Error('Nicht unterstütztes Inhaltselement');
    const appearance = getComputedStyle(source);
    if (source.hidden || appearance.display === 'none' || appearance.visibility === 'hidden' || appearance.opacity === '0' || source.style.backgroundImage) {
      throw new Error('Vorlage enthält gesondert formatierte oder verborgene Inhalte');
    }
    const tag = source.tagName;
    const output = tag === 'SPAN' || tag === 'FONT' ? document.createDocumentFragment() : element(tag === 'DIV' ? 'section' : tag.toLowerCase());
    if (output.nodeType === 1) {
      for (const key of ['title', 'lang', 'dir']) if (source.hasAttribute(key)) output.setAttribute(key, source.getAttribute(key));
      if (tag === 'A') {
        if (source.hasAttribute('href')) output.setAttribute('href', safeLink(source.getAttribute('href')));
        if (source.getAttribute('target') === '_blank') { output.target = '_blank'; output.rel = 'noopener noreferrer'; }
      }
      if (tag === 'IMG') {
        for (const key of ['src', 'srcset', 'sizes', 'alt', 'width', 'height', 'loading', 'decoding']) {
          if (source.hasAttribute(key)) output.setAttribute(key, source.getAttribute(key));
        }
      }
      if (tag === 'OL') for (const key of ['start', 'reversed', 'type']) if (source.hasAttribute(key)) output.setAttribute(key, source.getAttribute(key));
      if (tag === 'LI' && source.hasAttribute('value')) output.setAttribute('value', source.getAttribute('value'));
    }
    for (const child of source.childNodes) output.append(copyNode(child));
    return output;
  }
  function copyValue(source) {
    const output = element('section', 'tsp-copy');
    for (const child of source.childNodes) output.append(copyNode(child));
    if (fingerprints(output) !== fingerprints(source)) throw new Error('Inhaltsvergleich fehlgeschlagen');
    return output;
  }
  function bulletParagraphs(root) {
    for (const paragraph of root.querySelectorAll('p')) {
      if (!paragraph.querySelector('br') || Array.from(paragraph.children).some(n => n.tagName !== 'BR' && n.querySelector('br'))) continue;
      const lines = [document.createDocumentFragment()];
      for (const child of paragraph.childNodes) {
        if (child.nodeType === 1 && child.tagName === 'BR') lines.push(document.createDocumentFragment());
        else lines[lines.length - 1].append(child.cloneNode(true));
      }
      const nonempty = lines.filter(line => cleanText(line.textContent) || line.querySelector('img'));
      if (nonempty.length < 2 || nonempty.some(line => !/^\s*•/.test(line.textContent))) continue;
      const list = element('ul');
      for (const line of nonempty) {
        const item = element('li'); item.append(line);
        const walker = document.createTreeWalker(item, 4);
        let first;
        while ((first = walker.nextNode())) if (first.nodeValue.trim()) { first.nodeValue = first.nodeValue.replace(/^\s*•\s*/, ''); break; }
        list.append(item);
      }
      paragraph.replaceWith(list);
    }
  }
  function cellsOf(source) {
    if (source.matches('table')) {
      if (source.querySelector('table,caption,thead,tfoot') || (source.getAttribute('width') !== '670' && !/width\s*:\s*670(?:px)?\b/i.test(source.getAttribute('style') || ''))) {
        throw new Error('Unbekannte Tabellenstruktur');
      }
      const rows = Array.from(source.rows);
      if (rows.length < 2 || rows.some(row => row.cells.length !== 2 || Array.from(row.cells).some(cell => cell.colSpan !== 1 || cell.rowSpan !== 1))) {
        throw new Error('Keine eindeutigen Feld-Wert-Paare');
      }
      const cells = rows.map(row => Array.from(row.cells));
      if (!cells.some(([label]) => /#8f0b88/i.test(label.getAttribute('style') || ''))) throw new Error('Unbekannte Tabellenvorlage');
      return cells;
    }
    const children = Array.from(source.children);
    if (children.length < 4 || children.length % 2 || children.some(child => !child.classList.contains('customcell'))) throw new Error('Unvollständige customtable');
    if (Array.from(source.childNodes).some(n => n.nodeType === 3 && n.textContent.trim())) throw new Error('Zusätzlicher Text außerhalb der Felder');
    return children.filter((_, index) => index % 2 === 0).map((label, index) => [label, children[index * 2 + 1]]);
  }
  function parse(source) {
    const pairs = cellsOf(source);
    const raw = pairs.map(([label, value]) => ({
      label, value,
      title: cleanText(label.textContent).replace(/:\s*$/, '')
    }));
    const hasNamedDescription = raw.some(item => item.title && descriptionKeys.has(labelKey(item.title)));
    let syntheticDescriptionUsed = false;
    const fields = raw.map(({ label, value, title: rawTitle }) => {
      if ([label, value].some(cell => cell.hidden || getComputedStyle(cell).display === 'none' || getComputedStyle(cell).visibility === 'hidden')) throw new Error('Vorlage enthält verborgene Felder');
      let title = rawTitle;
      if (!title) {
        if (hasNamedDescription || syntheticDescriptionUsed || !cleanText(value.textContent)) throw new Error('Unbekannte Feldbezeichnung');
        title = 'Beschreibung';
        syntheticDescriptionUsed = true;
      }
      if (title.length > 100 || label.querySelector('img,a,table,ul,ol,br')) throw new Error('Unbekannte Feldbezeichnung');
      return { title, key: labelKey(title), original: value, content: copyValue(value) };
    });
    if (new Set(fields.filter(f => isAnchorKey(f.key)).map(f => f.key)).size < 2) throw new Error('Keine bekannte Produktvorlage');
    return fields;
  }
  function makeFold(title, body, name) {
    const fold = element('details', 'tsp-fold');
    const summary = element('summary', 'tsp-summary');
    const badge = element('span', 'tsp-icon-badge'); badge.append(icon(name));
    const displayTitle = cleanText(title).replace(/:\s*$/, '');
    summary.append(badge, element('span', 'tsp-summary-label', displayTitle), icon('chevron', 'tsp-chevron'));
    body.classList.add('tsp-fold-body');
    fold.append(summary, body);
    return fold;
  }
  function splitDescription(field) {
    const groups = [{ heading: '', body: element('section', 'tsp-copy') }];
    for (const node of Array.from(field.content.childNodes)) {
      if (node.nodeType === 1 && ['P','H2','H3','H4','H5','H6'].includes(node.tagName) && !node.querySelector('img,a') && sectionKeys.has(labelKey(node.textContent))) {
        groups.push({ heading: cleanText(node.textContent), body: element('section', 'tsp-copy') });
      } else groups[groups.length - 1].body.append(node);
    }
    return groups;
  }
  function build(fields) {
    const output = element('section', 'tsp-description');
    const introduction = element('section', 'tsp-introduction');
    const details = element('section', 'tsp-product-details');
    const heading = element('h3', 'tsp-heading'); heading.append(icon('gem'), document.createTextNode('Produktdetails'));
    const cards = element('section', 'tsp-fields'); cards.setAttribute('aria-label', 'Produktdetails');
    details.append(heading, cards);
    const folds = element('section', 'tsp-folds');
    const ledger = [];
    for (const field of fields) {
      if (descriptionKeys.has(field.key)) {
        const groups = splitDescription(field);
        const long = cleanText(field.original.textContent).length > 600 || groups.length > 1;
        ledger.push({ field, groups });
        for (const group of groups) {
          bulletParagraphs(group.body);
          const hasContent = cleanText(group.body.textContent) || group.body.querySelector('img');
          if (!hasContent && !group.heading) continue;
          if (long) {
            const name = /pflege/i.test(group.heading) ? 'sparkles' : group.heading ? 'list' : 'copy';
            folds.append(makeFold(group.heading || field.title, group.body, name));
          } else introduction.append(group.body);
        }
      } else {
        const card = element('dl', 'tsp-field');
        if (cleanText(field.content.textContent).length > 110 || field.content.querySelector('img,ul,ol')) card.classList.add('tsp-field-wide');
        const value = element('dd'); value.append(field.content);
        card.append(element('dt', '', field.title), value);
        cards.append(card);
        ledger.push({ field, groups: [{ heading: '', body: field.content }] });
      }
    }
    if (introduction.childNodes.length) output.append(introduction);
    if (cards.childNodes.length) output.append(details);
    if (folds.childNodes.length) output.append(folds);
    if (!output.childNodes.length) throw new Error('Leere Ausgabe');
    // Verify every field separately after rearrangement, including image and link targets.
    for (const entry of ledger) {
      const temporary = element('section');
      for (const group of entry.groups) {
        temporary.append(document.createTextNode(group.heading), group.body.cloneNode(true));
      }
      if (fingerprints(temporary) !== fingerprints(entry.field.original)) throw new Error('Inhaltsverlust bei der Anordnung');
    }
    return output;
  }
  function convertNotices(block) {
    let converted = 0;
    for (const source of block.querySelectorAll('.tf-product .tf-prose')) {
      if (source.hasAttribute(SOURCE_MARK)) continue;
      const label = source.querySelector(':scope > [data-side="label"]');
      const value = source.querySelector(':scope > [data-side="value"]');
      if (!label || !value || !noticeKeys.has(labelKey(label.textContent))) continue;
      if (!cleanText(value.textContent) && !value.querySelector('img')) continue;
      if (Array.from(source.children).some(node => node !== label && node !== value)) continue;
      if (Array.from(source.childNodes).some(node => node.nodeType === 3 && cleanText(node.textContent))) continue;
      let output;
      try {
        const body = copyValue(value);
        const fold = makeFold(label.textContent, body, 'copy');
        const heading = element('h3', 'tsp-summary-label', cleanText(label.textContent).replace(/:\s*$/, ''));
        fold.querySelector('.tsp-summary-label').replaceWith(heading);
        const folds = element('section', 'tsp-folds');
        folds.append(fold);
        output = element('section', 'tsp-description tsp-notice');
        output.append(folds);
        source.before(output);
        if (getComputedStyle(output).getPropertyValue('--tsp-ready').trim() !== '1' || getComputedStyle(output).display === 'none') throw new Error('Hinweisdarstellung nicht verfügbar');
        if (fingerprints(body) !== fingerprints(value)) throw new Error('Hinweisvergleich fehlgeschlagen');
        source.setAttribute(SOURCE_MARK, '1');
        converted++;
      } catch (error) {
        if (output) output.remove();
        source.removeAttribute(SOURCE_MARK);
        diagnostics.set(block, error.message);
      }
    }
    return converted;
  }
  function installStyle() {
    if (document.getElementById('taffstyle-description-style')) return;
    const style = element('style'); style.id = 'taffstyle-description-style'; style.textContent = CSS + '\n.tsp-description.tsp-notice .tsp-summary h3.tsp-summary-label { margin: 0; padding: 0; font: inherit; color: inherit; text-transform: none; letter-spacing: inherit; }\n.tsp-description.tsp-notice .tsp-copy > section { margin-bottom: 10px; }\n.tsp-description.tsp-notice .tsp-copy > section:last-child { margin-bottom: 0; }';
    document.head.append(style);
  }
  function hideLegacyPromos(block) {
    const pattern = /^weitere\b.{0,100}\bangebote\b.{0,60}\bshop\b\s*!?$/i;
    for (const node of block.querySelectorAll('div,p,strong,span')) {
      const text = cleanText(node.textContent);
      if (!text || text.length > 180 || !pattern.test(text)) continue;
      node.setAttribute(PROMO_MARK, '1');
      let next = node.nextElementSibling;
      while (next && !cleanText(next.textContent) && !next.querySelector('img,a,table,ul,ol,button,input,video')) {
        next.setAttribute(PROMO_MARK, '1');
        next = next.nextElementSibling;
      }
    }
  }
  function hideLegacyMedia(block) {
    for (const img of block.querySelectorAll('img')) {
      if (img.closest('.tsp-description')) continue;
      const src = img.getAttribute('src') || '';
      if (!/taffstyle\.de\/ebay\//i.test(src)) continue;
      let node = img;
      while (node.parentElement && node.parentElement !== block) {
        const parent = node.parentElement;
        if (parent.querySelector('table,.customtable,.customcell')) break;
        node = parent;
      }
      node.setAttribute(LEGACY_MEDIA_MARK, '1');
      const previous = node.previousElementSibling;
      if (previous && previous.tagName === 'BR' && /clear/i.test(previous.getAttribute('style') || previous.getAttribute('clear') || '')) {
        previous.setAttribute(LEGACY_MEDIA_MARK, '1');
      }
      const next = node.nextElementSibling;
      if (next && next.tagName === 'BR' && /clear/i.test(next.getAttribute('style') || next.getAttribute('clear') || '')) {
        next.setAttribute(LEGACY_MEDIA_MARK, '1');
      }
    }
  }
  function convert(block) {
    if (block.querySelector('.tsp-description') || block.querySelector('[' + SOURCE_MARK + ']')) return false;
    const candidates = Array.from(new Set([
      ...block.querySelectorAll('table,.customtable'),
      ...Array.from(block.querySelectorAll('.customcell'), cell => cell.parentElement)
    ])).filter(node => {
      if (!node || !block.contains(node)) return false;
      if (node.matches('table')) return !node.parentElement.closest('table,.customtable');
      const children = Array.from(node.children);
      return children.length >= 4
        && children.length % 2 === 0
        && children.every(child => child.classList.contains('customcell'));
    });
    if (candidates.length !== 1) { diagnostics.set(block, 'Keine eindeutige unterstützte Vorlage'); return false; }
    const source = candidates[0];
    if (source.hidden || getComputedStyle(source).display === 'none') return false;
    let output, parentMarked = false;
    const parent = source.parentElement;
    try {
      output = build(parse(source));
      source.before(output);
      if (getComputedStyle(output).getPropertyValue('--tsp-ready').trim() !== '1' || getComputedStyle(output).display === 'none') throw new Error('Neue Darstellung nicht verfügbar');
      // The original content is hidden only after the replacement is complete and checked.
      source.setAttribute(SOURCE_MARK, '1');
      if (source.matches('table') && parent.tagName === 'DIV' && /width\s*:\s*670px/i.test(parent.getAttribute('style') || '')) {
        parent.classList.add('tsp-legacy-wrapper'); parentMarked = true;
      }
      records.set(source, { output, parent, parentMarked });
      diagnostics.set(block, 'Umgestellt: ' + source.tagName.toLowerCase());
      return true;
    } catch (error) {
      if (output) output.remove();
      source.removeAttribute(SOURCE_MARK);
      if (parentMarked) parent.classList.remove('tsp-legacy-wrapper');
      diagnostics.set(block, error.message);
      return false;
    }
  }
  function scan() {
    if (!enabled) return 0;
    installStyle();
    let converted = 0;
    for (const block of document.querySelectorAll(BLOCK)) {
      hideLegacyPromos(block);
      hideLegacyMedia(block);
      if (convert(block)) converted++;
      converted += convertNotices(block);
    }
    for (const [source] of records) if (!source.isConnected) records.delete(source);
    return converted;
  }
  function restore() {
    enabled = false;
    if (observer) observer.disconnect();
    for (const block of document.querySelectorAll(BLOCK)) {
      for (const output of block.querySelectorAll('.tsp-description')) output.remove();
      for (const source of block.querySelectorAll('[' + SOURCE_MARK + ']')) source.removeAttribute(SOURCE_MARK);
      for (const promo of block.querySelectorAll('[' + PROMO_MARK + ']')) promo.removeAttribute(PROMO_MARK);
      for (const media of block.querySelectorAll('[' + LEGACY_MEDIA_MARK + ']')) media.removeAttribute(LEGACY_MEDIA_MARK);
      for (const wrapper of block.querySelectorAll('.tsp-legacy-wrapper')) wrapper.classList.remove('tsp-legacy-wrapper');
    }
    records.clear();
  }
  function schedule() {
    if (queued || !enabled) return;
    queued = true;
    queueMicrotask(() => { queued = false; scan(); });
  }
  function start() {
    if (!enabled) return;
    scan();
    document.addEventListener('shopify:section:load', schedule);
    observer = new MutationObserver(changes => {
      for (const change of changes) for (const node of change.addedNodes) {
        if (node.nodeType !== 1 || node.closest('.tsp-description')) continue;
        if (node.matches(BLOCK) || node.querySelector(BLOCK) || node.closest(BLOCK)) { schedule(); return; }
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }
  window[KEY] = {
    version: '1.3.1', scan, restore,
    status: () => Array.from(document.querySelectorAll(BLOCK), block => ({ converted: !!block.querySelector('.tsp-description'), reason: diagnostics.get(block) || 'Noch nicht geprüft' }))
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();

/* Lucide icon license:
ISC License

Copyright (c) 2026 Lucide Icons and Contributors

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted, provided that the above
copyright notice and this permission notice appear in all copies.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES
WITH REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF
MERCHANTABILITY AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR
ANY SPECIAL, DIRECT, INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES
WHATSOEVER RESULTING FROM LOSS OF USE, DATA OR PROFITS, WHETHER IN AN
ACTION OF CONTRACT, NEGLIGENCE OR OTHER TORTIOUS ACTION, ARISING OUT OF
OR IN CONNECTION WITH THE USE OR PERFORMANCE OF THIS SOFTWARE.

---

The following Lucide icons are derived from the Feather project:

airplay, alert-circle, alert-octagon, alert-triangle, aperture, arrow-down-circle, arrow-down-left, arrow-down-right, arrow-down, arrow-left-circle, arrow-left, arrow-right-circle, arrow-right, arrow-up-circle, arrow-up-left, arrow-up-right, arrow-up, at-sign, calendar, cast, check, chevron-down, chevron-left, chevron-right, chevron-up, chevrons-down, chevrons-left, chevrons-right, chevrons-up, circle, clipboard, clock, code, columns, command, compass, corner-down-left, corner-down-right, corner-left-down, corner-left-up, corner-right-down, corner-right-up, corner-up-left, corner-up-right, crosshair, database, divide-circle, divide-square, dollar-sign, download, external-link, feather, frown, hash, headphones, help-circle, info, italic, key, layout, life-buoy, link-2, link, loader, lock, log-in, log-out, maximize, meh, minimize, minimize-2, minus-circle, minus-square, minus, monitor, moon, more-horizontal, more-vertical, move, music, navigation-2, navigation, octagon, pause-circle, percent, plus-circle, plus-square, plus, power, radio, rss, search, server, share, shopping-bag, sidebar, smartphone, smile, square, table-2, tablet, target, terminal, trash-2, trash, triangle, tv, type, upload, x-circle, x-octagon, x-square, x, zoom-in, zoom-out

The MIT License (MIT) (for the icons listed above)

Copyright (c) 2013-present Cole Bemis

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in all
copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
SOFTWARE.

*/

